/**
 * Diese Datei enthält Referenzen auf alle prekompilierten Templates
 * und registriert den notwendigen Loader für den TemplateCache.
 */

var TemplateCache = require('TemplateCache');
var Registry = require('registry');

var PREFIX = '';

var TEMPLATES = {
	/* Header */
	'cart-items-template': require('./header/cart-items-template.html'),
	'favorites-template': require('./header/favorites-template.html'),
	'sitesearch-template': require('./header/sitesearch-template.html'),

	/* Engine */
	'datepicker-controls': require('./engine/datepicker-controls.html'),
	'datepicker-item-info': require('./engine/datepicker-item-info.html'),
	'SortOrderTemplate': require('./engine/SortOrderTemplate.html'),
	'reserva-people-template': require('./engine/reserva-people-template.html'),
	'loader-results': require('./engine/loader-results.html'),
	'no-results': require('./engine/no-results.html'),
	'result-template': require('./engine/result-template.html'),
	'SidebarTemplate': require('./engine/SidebarTemplate.html'),
	'result-error': require('./engine/result-error.html'),
	'result-error-validate': require('./engine/result-error-validate.html'),
	'filterinfo': require('./engine/filterinfo.html'),

	/* Browser */
	'browser/SidebarTemplate': require('./browser/SidebarTemplate.html'),
	'browser/SortOrderTemplate': require('./browser/SortOrderTemplate.html'),
	'browser/LoadingIndicator': require('./browser/LoadingIndicator.html'),
	'browser/ResultError': require('./browser/ResultError.html'),
	'browser/ResultTemplate': require('./browser/ResultTemplate.html'),

	/* Miniengine */
	'timetable-template': require('./miniengine/timetable-template.html'),
	'pricetable-template': require('./miniengine/pricetable-template.html'),
	'classes-template': require('./miniengine/classes-template.html'),
	'products-template': require('./miniengine/products-template.html'),
	'ratings-template': require('./miniengine/ratings-template.html'),
	'reserva-yeartable': require('./miniengine/reserva-yeartable.html'),

	/* Interest Filter */
	'interest-filter': require('./interest-filter.html'),
};

if ( Registry.get("Customer").Alpentraum ) {
	TEMPLATES['result-template'] = require('./engine/result-template-alpentraum.html');
}

if ( Registry.get("Customer").Montana ) {
	TEMPLATES['result-template'] = require('./engine/result-template-montana.html');
}

module.exports = {
	/**
	 * Registriert den webpack-Loader im TemplateCache
	 */
	register: function() {
		TemplateCache.registerLoader("webpack", function(ident) {
			if ( PREFIX && TEMPLATES[PREFIX + ident] ) {
				return TEMPLATES[PREFIX + ident]
			}
			return TEMPLATES[ident];
		});
	},

	/**
	 * Definiert einen Prefix der beim Lookup zuerst geprüft wird.
	 * Hack um doppelte Template-Namen bei Engine/Browser aufzulösen.
	 */
	setPrefix: function(prefix) {
		PREFIX = prefix;
	},
};



// WEBPACK FOOTER //
// /Users/bm/app/code/jsapps/modules/reserva/templates/main.js